import { useEffect, useRef, useState } from "react";

export function useFlagTimer() {
  const [elapsed, setElapsed] = useState(0);
  const [running, setRunning] = useState(false);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const startTimeRef = useRef<Date | null>(null);
  const activeFlagIdRef = useRef<string | null>(null);

  const start = () => {
    startTimeRef.current = new Date();
    setElapsed(0);
    setRunning(true);
  };

  const stop = (): Date | null => {
    setRunning(false);
    return startTimeRef.current;
  };

  const reset = () => {
    setRunning(false);
    setElapsed(0);
    startTimeRef.current = null;
    activeFlagIdRef.current = null;
  };

  const setActiveFlagId = (id: string | null) => {
    activeFlagIdRef.current = id;
  };

  const getActiveFlagId = (): string | null => activeFlagIdRef.current;

  useEffect(() => {
    if (running) {
      intervalRef.current = setInterval(
        () => setElapsed((s) => s + 1),
        1000
      );
    } else {
      if (intervalRef.current) clearInterval(intervalRef.current);
    }
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [running]);

  const format = (s: number) => {
    const m = Math.floor(s / 60)
      .toString()
      .padStart(2, "0");
    const sec = (s % 60).toString().padStart(2, "0");
    return `${m}:${sec}`;
  };

  return {
    elapsed,
    running,
    startTime: startTimeRef.current,
    start,
    stop,
    reset,
    format,
    setActiveFlagId,
    getActiveFlagId,
  };
}